import Sortable from 'sortablejs';
let dropzones = []
let sortables = []
const defineTransactions = (evt) => {
  const transactions = [];

  // Don't allow Full Time resource to split if there are already two revelers assigned to the resource
  if (evt.to.id !== 'pool' && evt.to.dataset.resourceType === 'Full Time' && evt.to.childElementCount > 1) {
    transactions.push('RESOURCE_FULL');
  }
  // Don't allow Part Time resource to split
  if (evt.to.id !== 'pool' && evt.to.dataset.resourceType === 'Part Time' && evt.to.childElementCount > 0) {
    transactions.push('RESOURCE_FULL');
  }
  // Reveler is being moved from the pool
  if (evt.from.id === 'pool') {
    transactions.push('FROM_POOL');
  }
  // Reveler is being moved to the pool
  if (evt.to.id === 'pool') {
    transactions.push('TO_POOL');
  }
  // Check if a resource is being split between two revelers
  if (evt.to.children.length === 2) {
    transactions.push('IS_SPLIT');
  }
  // Check if the resource currently has an assigned reveler
  if (evt.to.children.length === 2) {
    transactions.push('HAS_REVELER');
  }
  // Check to see if the reveler is dragged and dropped to the same place
  if (evt.to.id === evt.from.id) {
    transactions.push('SAME_DROPZONE');
  }
  // Check if a resourced Reveler is being moved directly to another resource
  if (evt.to.id !== 'pool' && evt.from.id !== 'pool') {
    transactions.push('BETWEEN_RESOURCES');
  }

  return transactions;
}

const handleRevelerIsMovingEvent = (evt) => {
  const transactions = defineTransactions(evt);
  const action = (type) => transactions.includes(type);

  if (action('RESOURCE_FULL')) {
    return false;
  }
  return null
}

const handleRevelerHasDroppedEvent = (evt, hook, selector) => {
  const transactions = defineTransactions(evt);
  const action = (type) => transactions.includes(type);
  const revelerId = evt.item.dataset.revelerId;

  if (action('SAME_DROPZONE')) {
    return;
  }

  if (action('IS_SPLIT')) {
    const areRevelersTheSame = action('HAS_REVELER') && Array.from(evt.to.children).every((child) => child.dataset.revelerId === revelerId);
    const currentlyResourcedReveler = action('HAS_REVELER') && !areRevelersTheSame ? Array.from(evt.to.children).filter((child) => child.dataset.revelerId !== revelerId)[0].dataset.revelerId : revelerId;

    if (areRevelersTheSame) {
      transactions.push('SAME_REVELER')
    }

    hook.pushEventTo(selector, 'set_assignment_to_socket', {
      transactions,
      revelerId,
      currentlyResourcedReveler,
      draggedTo: evt.to.id,
      draggedFrom: evt.from.id,
    });
  }

  if (!action('IS_SPLIT')) {
    hook.pushEventTo(selector, 'set_assignment_to_socket', {
      transactions,
      revelerId,
      draggedTo: evt.to.id,
      draggedFrom: evt.from.id,
    });
  }
}

function compareDropZones(zones1, zones2) {
  const originalDropZones = Array.from(zones1).map(({id}) => id)
  const newDropZones = Array.from(zones2).map(({id}) => id)

  return JSON.stringify(originalDropZones) === JSON.stringify(newDropZones)
}

function addDropZones(zones, hook) {
  const selector = `#${hook.el.id}`;

  zones.forEach((dropzone) => {
    const sort = new Sortable(dropzone, {
      animation: 0,
      group: 'shared',
      draggable: '.draggable',
      ghostClass: 'sortable-ghost',
      onMove: (evt) => handleRevelerIsMovingEvent(evt),
      onEnd: (evt) => handleRevelerHasDroppedEvent(evt, hook, selector),
    });

    sortables.push(sort)
  });
}

function init(hook) {
  dropzones = document.querySelectorAll('.dropzone')

  addDropZones(dropzones, hook)
}

function update(hook) {
  const newDropzones = document.querySelectorAll('.dropzone')
  const same = compareDropZones(dropzones, newDropzones)

  if (!same) {
    sortables.forEach((sortable) => {
      sortable.destroy()
    })
    sortables = []

    dropzones = newDropzones

    addDropZones(dropzones, hook)
  }
}

export default {
  mounted() {
    init(this)
  },
  updated() {
    update(this)
  },
};
